import React from "react"
import styles from "./body-copy.module.scss"
import RichText from "components/rich-text"

const BodyCopy = ({richText, className=""}) => {
 return <RichText className={`${styles.element} ${className}`} text={richText} />
}

export default BodyCopy